import React, { Component } from "react";
import { Layout, Menu, Radio, Button, Checkbox, message, Pagination,Form,Input } from "antd";
import Header from "../../components/header";
import { reqDeletePaper, reqPaper, reqPickQue, reqIllCaseList, reqAllCaseList, reqCaseList ,reqModification ,reqPublishexam} from "../../api";

import './preview.less'
import Modal from "antd/es/modal";

const { Content, Sider } = Layout;

/**
 * 预览试卷病例考核的路由组件
 */
 class PreviewIll extends Component {

    state = {
        pid: 0,
        paper: {},
        qCase: {},
        pStatus: "inline-block",
        pStatusN: "none",
        totalScore: 0,
        caseList: {},
        particularsList: {},
        compile: false,
        topic: false,
        choice: "",
        totalwww: "",
        caseId: "",
        checked: true,
        caseIdwww: "",
        casevisible:"",
        papername:'',
        caseStatus:''
    };

    getcaseExam = async(id) => {
        const result = await reqPublishexam(id);
        if (result.code === '000000') {
            // console.log(result.data);
            // this.stateDRAFT
            this.setState({
                caseStatus: result.data,
            })
        }
    }

    preview = (e, id) => {
        switch (id) {
            case 1:
                this.props.history.replace("/previewCom");
                break;
            case 2:
                this.props.history.replace("/previewIll");
                break;
            case 3:
                this.props.history.replace("/paper");
                break;
            default:
                this.props.history.replace("/previewCom");
        }
    };



    getPaper = async (id) => {
        const result = await reqPaper(id);
        if (result.data.qcase) {
            this.totalwww = result.data.qcase.total;
        }
        // let qbScore = 0;
        /* if (result.data.qb) {
            qbScore = result.data.qb.scorePer * result.data.qb.total;
        } */
        let totalScore = 0;
        // console.log(result.data);
        for (let item in result.data) {
            let obj = result.data[item];
            if (obj.scorePer) {

                totalScore = totalScore + obj.scorePer * obj.total;
                // console.log("属性" + item + "进行了加操作,当前总值为：" + totalScore);
            }
            // console.log(result.data[item]);
        }
        // let totalScore = result.data.qa.scorePer * result.data.qa.total + qbScore + result.data.qx.scorePer * result.data.qx.total + result.data.qcase.scorePer * result.data.qcase.total;

        if (result.data.qcase) {
            this.setState({
                paper: result.data,
                qCase: result.data.qcase,
                // qCase: Boolean(result.data.qcase?result.data.qcase:""),
                totalScore: totalScore,
            })
        } else {
            this.setState({
                paper: result.data,
                // qCase: Boolean(result.data.qcase?result.data.qcase:""),
                totalScore: totalScore,
            })
        }

    };
    pubPaper = async () => {
        this.props.history.replace("/paper");
    };

    pickQue = async () => {
        const result = await reqPickQue(this.state.pid, "CASE");
        if (result.code === '000000') {
            message.success("替换成功");
            this.getPaper(this.state.pid)
        }
    };

    getIllCaseList = async (data) => {
        const result = await reqIllCaseList(data);
        // console.log(result.data);
        if (result.code === '000000') {
            this.setState({
                caseList: result.data,
                total: result.data.total,
                page: result.data.page
            })
        } else {
            message.error(result.msg);
        }
    };

    compileCase = async () => {
        this.choice = "";
        this.caseId = "";
        let data = {
            page: 1,
            size: 10,
            withDesc: true,
            qtCntLimit: this.totalwww
        };
        this.getIllCaseList(data);
        // this.ids = item.refId
        this.setState({
            compile: true,
        })
    };

    replaceCase = async () => {
        if (this.choice) {
            const result = await reqAllCaseList(this.choice);
            if (result.code === '000000') {
                message.info("请选择相同数量的题目");
                this.setState({
                    particularsList: result.data,
                    compile: false,
                    topic: true,
                })
            }
        } else {
            message.info("请先选择要替换的病例");
        }
    };

    replaceDetails = async () => {
        if (this.caseId) {
            const result = await reqCaseList(this.state.pid, this.choice, this.caseId);
            if (result.code === '000000') {
                message.success("替换成功");
                this.getPaper(this.state.pid)
                this.setState({
                    topic: false
                })
                this.choice = "";
                this.caseId = ""

            } else {
                message.error(result.msg);
            }
        }else{
            message.error("请先选择要替换的病例");
        }
    };

    showTotal = (total) => {
        return '共' + total + '条记录';
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    pageClick = async page => {
        let data = {
            page: page,
            size: 10
        };
        this.getIllCaseList(data);
    };

    maxPic = (pics) => {
        Modal.info({
            title: '',
            width: '40%',
            okText: '关闭',
            icon: 'none',
            className: 'pic',
            content: (
                <div style={{ wordBreak: "break-all" }}>
                    <span style={{ wordBreak: "break-all" }}></span>
                    <img style={{ width: "100%", height: "auto" }} src={global.constant.uploadImage + pics[0]} />
                </div>
            ),
            onOk() { },
        });
    };

    showDeleteModal = () => {
        this.setState({
            visible: true
        });
    };

    deletePaper = async () => {
        const result = await reqDeletePaper(this.state.pid);
        if (result.code === '000000') {
            sessionStorage.clear();
            this.props.history.push("/paper");
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            compile: false,
            topic: false,
            casevisible:false
        });
        this.choice = "";
        this.caseId = ""
    };

    //修改试卷模态框
    amendcase= () => {
        this.setState({
            casevisible: true
        })
    }

    amendcasehandleOk = async () =>{
        this.props.form.validateFields(async (err,value) => {
            if (!err) {
                const result = await reqModification(this.state.paper.id, value.name);
                if (result.code === '000000') {
                    this.getPaper(this.state.pid)
                    message.success('修改成功');
                    this.setState({
                        casevisible: false
                    })
                }
            }
        })
        
    }

    //修改试卷名称
    handleChange = e => {
        this.papername =  e.target.value
    };

    componentDidMount = async () => {
        this.setState({
            pid: sessionStorage.getItem("pid"),
            pStatus: sessionStorage.getItem("pStatus") ? sessionStorage.getItem("pStatus") : "inline-block",
            pStatusN: sessionStorage.getItem("pStatusN"),
        });
        this.getPaper(sessionStorage.getItem("pid"));
        this.getcaseExam(sessionStorage.getItem("pid"));
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { total, page, paper, qCase, totalScore, visible, compile, caseList, particularsList, topic, casevisible ,caseStatus} = this.state;
        const self = this;
        const onChange = e => {
            this.choice = e.target.id
        };
        const onChangeCheck = checkedValues => {
            this.caseId = checkedValues.join(",");
            // console.log(this.caseId);
        }
        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Sider className='case_left'>
                        <Menu style={{ width: 170 }} selectedKeys={['2']}>
                            <Menu.Item id={3} key={3} title={'返回'} onClick={() => this.preview(this, 3)} style={{ display: this.state.pStatusN }}>
                                返回
                            </Menu.Item>
                            <Menu.Item id={1} key={1} title={'综合考核'} onClick={() => this.preview(this, 1)}>
                                综合考核
                            </Menu.Item>
                            <Menu.Item id={2} key={2} title={'病例考核'} onClick={() => this.preview(this, 2)}>
                                病例考核
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Content>
                        <div className='preview'>
                            <div className='pre_title'>
                                <div>
                                    <span>试卷名称：</span>
                                    {/* <input defaultValue={paper.name} /> */}
                                    <span>{paper.name}</span>
                                    <Button type="primary" className='blue' onClick={this.amendcase.bind(this)}>修改</Button>
                                </div>
                                <div style={{ marginLeft: 50 }}>
                                    <span>试卷总分：</span>
                                    <span>{totalScore}分</span>
                                </div>
                            </div>
                            <div className='pre_publish'>{caseStatus == 'PUBLISHED'?'试卷已发布，不能对病例进行修改 ':''}</div>
                            <div className='all_num'>
                                <div className='ill_title'>
                                    <div style={{ display: "flex", position: "relative" }}>
                                        <div className='case_title' style={{ display: this.state.qCase ? 'block' : 'none' }}>{qCase.title}</div>
                                        {/* <div className='case_title' v-else>无</div> */}
                                        <div className='case_redact' onClick={self.compileCase.bind(self)}>{caseStatus == 'DRAFT'?'编辑':''}</div>
                                    </div>
                                    <div>{qCase.description}</div>

                                </div>
                                <div>
                                    {
                                        qCase.questions && qCase.questions.map(function (item, index) {
                                            return (
                                                <div key={index}>
                                                    {
                                                        item.questions && item.questions.map(function (ques, ins) {
                                                            return (
                                                                <div id={ques.id} key={ins} className='list_title ill_con'>
                                                                    <span style={{ fontWeight: 'bold' }}>第{index + 1}题</span>  {ques.question}：
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <Checkbox.Group className='list_checkbox' value={item.questions[0].correctAnswer.split("|")}>
                                                        {
                                                            item.options && item.options.map(function (order, i) {
                                                                return (
                                                                    <Checkbox value={order.optionKey} key={i}>
                                                                        <span className='list_circle'>{order.optionKey}</span>{order.optionValue}
                                                                    </Checkbox>
                                                                )
                                                            })
                                                        }
                                                    </Checkbox.Group>
                                                    <div className='list_img'>
                                                        <img onClick={self.maxPic.bind(self, item.imgs)}
                                                            src={item.imgs && global.constant.uploadImage + item.imgs[0]} />
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                            <div className='bottom_btn' style={{ display: this.state.pStatus }}>
                                <Button className='gray' onClick={this.showDeleteModal.bind(this)}>取消</Button>
                                <Button className='gray' onClick={this.pickQue.bind(this)}>重新抽题</Button>
                                <Button className='blue' onClick={this.pubPaper.bind(this)}>生成试卷</Button>
                            </div>
                        </div>
                        <Modal
                            title="提示"
                            visible={visible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deletePaper}
                            onCancel={this.handleCancel}>
                            <div>确定放弃生成当前试卷吗？</div>
                        </Modal>
                        <Modal title={'编辑'} visible={compile} centered width={550}
                            onCancel={this.handleCancel} okText="确定" cancelText={"取消"} destroyOnClose='true' onOk={this.replaceCase}
                        >
                            <div style={{ wordBreak: "break-all" }}>

                                <Radio.Group onChange={onChange} style={{ width: '100%' }}>
                                    {
                                        caseList.rows && caseList.rows.map(function (item, index) {
                                            return (
                                                <Radio value={item.title} key={index} id={`${item.id}`}>
                                                    <span id={item.id} key={index} className='list_circle1'>
                                                        {1 + index}. {item.title}
                                                    </span>
                                                    <div style={{ wordBreak: "break-all" }} className='list_circle2'>{item.description}</div>
                                                </Radio>
                                            )
                                        })
                                    }
                                </Radio.Group>
                                <Pagination total={total} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal} />
                            </div>
                        </Modal>
                        <Modal title={'请选择相同数量的题目'} visible={topic} centered width={550}
                            onCancel={this.handleCancel} okText="确定" cancelText={"取消"} destroyOnClose='true' onOk={this.replaceDetails}
                        >
                            <div style={{ wordBreak: "break-all" }}>
                                {
                                    <Checkbox.Group style={{ width: '100%' }} onChange={onChangeCheck}>
                                        {particularsList.questions && particularsList.questions.map(function (item, index) {

                                            return (
                                                <Checkbox value={item.id} key={index} >
                                                    <span id={item.id} key={index} className='list_circle1'>
                                                        {1 + index}. {item.question}
                                                    </span>
                                                    {
                                                        item.options && item.options.map(function (order, i) {
                                                            return (
                                                                <div key={i} className='list_radio'>
                                                                    {order.optionKey}. {order.optionValue}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Checkbox>
                                            )
                                        })
                                        }
                                    </Checkbox.Group>
                                }
                            </div>
                        </Modal>
                        <Modal width={600}  title="修改试卷名称" visible={casevisible} onOk={this.amendcasehandleOk}
                            onCancel={this.handleCancel}
                            okText="确认" cancelText="取消" destroyOnClose='true' >
                            <Form>
                                <Form.Item label='试卷名称'>
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入试卷名称!' }],
                                        initialValue: this.state.paper.name
                                    })(
                                        <Input style={{width:'400px'}} className='input' placeholder='请输入新增名称' />,
                                    )}
                                </Form.Item>
                            </Form>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const PreviewIllManage = Form.create()(PreviewIll);
export default PreviewIllManage;